import { formatDateByResolution } from "@productlane/lib/src/due-date"

import type { PillProps } from "./pill"
import { CalendarIcon } from "../icons/project/calendar-icon"
import { Pill } from "./pill"

interface LinearDueDateProps {
	className?: string
	dueDate: string | null
	dueDateResolution?: string | null
	withIcon?: boolean
	variant?: PillProps["variant"]
	size?: PillProps["size"]
	border?: PillProps["border"]
	iconClassName?: string
}

export const LinearDueDate = ({
	className,
	dueDate,
	dueDateResolution,
	withIcon = true,
	variant = "glass",
	size = "default",
	border = "default",
	iconClassName,
}: LinearDueDateProps) => {
	const formatDisplayDate = (
		dateString: string,
		resolution?: string | null,
	): string => {
		try {
			const date = new Date(dateString)
			if (isNaN(date.getTime())) {
				return dateString
			}

			const now = new Date()
			const today = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate())
			const targetDate = Date.UTC(
				date.getUTCFullYear(),
				date.getUTCMonth(),
				date.getUTCDate(),
			)

			if (targetDate === today) {
				return "Today"
			}

			return formatDateByResolution(date, resolution)
		} catch {
			return dateString
		}
	}

	return (
		<>
			{dueDate && (
				<Pill
					className={className}
					variant={variant}
					size={size}
					border={border}
					Icon={withIcon ? CalendarIcon : undefined}
					iconClassName={iconClassName}
				>
					{formatDisplayDate(dueDate, dueDateResolution)}
				</Pill>
			)}
		</>
	)
}
